module.exports = __webpack_public_path__ + "cd455783/img/dollar-icon.35c9d638.svg";